const removeDuplicatedTasks = (accumulator, current) => {
  if (accumulator.every(({ referenceId }) => referenceId !== current.referenceId)) {
    return [...accumulator, current];
  }
  return accumulator;
};
export {
  removeDuplicatedTasks
};
